import { styled } from "@mui/material/styles";
import { colors } from "@zapalacorp/tokens";

export const OrderTabDocumentStatusTitle = styled("span")(() => ({
  color: colors.gray800,
  fontFamily: "Manrope",
  fontSize: "14px",
  fontStyle: "normal",
  fontWeight: 600,
  lineHeight: "20px",
  letterSpacing: "0.1px",
}));

export const OrderTabDocumentStatusContainer = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "8px",

  position: "absolute",
  bottom: 0,
}));

export const OrderTabDocumentStatusBody = styled("div")(() => ({
  display: "flex",
  flexDirection: "row",
  gap: "8px",
}));
